import { api } from './client';
import type { LoginRequest, LoginResponse, MeResponse } from '../types/auth';

export const authApi = {
  login: (body: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', body).then((r) => r.data),

  logout: () => api.post<void>('/auth/logout').then((r) => r.data),

  me: () => api.get<MeResponse>('/auth/me').then((r) => r.data),
};
